export const OBJECT = {
  TKO: 'tko',
  CITY: 'settlement',
  REL: 'relation',
  CAR: 'car',
  CIRCLE: 'circle',
  OFFLINE: 'offline',
  GARBAGE: 'garbage',
  UNAUTHORIZED_HEAP: 'unauthorized_heap',
  UNAUTHORIZED_TKO: 'unauthorized_tko',
  MSN: 'msn',
  OPERATOR_TRANSPORT: 'transp',
  EQUIDISTANT: 'equidistant',
}
